const _getTypeMap = (field) => {
  if (field.element_type === "Text") {
    if (field.type === "Array") return "textarray";
    return "text";
  }

  if (field.element_type === "Single-Select") {
    if (field.source) {
      return "select";
    } else return "radio";
  }

  if (field.element_type === "DatePicker") {
    return "date";
  }

  if (field.element_type === "Integer") {
    return "text";
  }

  if (field.element_type === "File") {
    return "file";
  }

  return alert("Not found element type " + field.element_type);
};

const _getMapSource = (source) => {
  const sources = source.split("/");
  const resourceName = sources[sources.length - 1];
  return resourceName;
};

const getFieldBlock = ({
  field,
  occupations,
  subDistricts,
  districts,
  provinces,
  postcodes,
  lang,
}) => {
  //const field = form.fields.find((f) => f.id === field);

  if (field.id === "socials") return null;

  const type = _getTypeMap(field);
  let options, valueProperty;
  if (type === "select") {
    const resourceName = _getMapSource(field.source);
    if (resourceName === "occupations") {
      options = occupations;
      valueProperty = "name";
    } else if (resourceName === "sub-districts") {
      options = subDistricts;
      valueProperty = "name";
    } else if (resourceName === "districts") {
      options = districts;
      valueProperty = "name";
    } else if (resourceName === "provinces") {
      options = provinces;
      valueProperty = "name";
    } else if (resourceName === "postcodes") {
      options = postcodes;
      valueProperty = "code";
    } else if (resourceName === "socials") {
      return null;
    } else {
      console.error("Can't find resource " + resourceName);
      return null;
    }
  }

  if (type === "radio") {
    options = field.values?.map((v) => ({
      code: v.code,
      name: v.name,
    }));
  }

  const result = {
    key: field.id,
    text: lang
      ? lang === "th"
        ? field.i18n["th-TH"].name
        : field.i18n["en-US"].name
      : field.name, //or field.i18n["th-TH"].name
    type: type,
    options: options,
    pattern: field.pattern,
    required: field.required,
    initialValue: field.initial_value,
    section: field.section,
    valueProperty: valueProperty,
  };
  return result;
};

export { getFieldBlock };
